import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Analytics } from "@vercel/analytics/react";
import { isVercelHosted } from "./lib/analytics";
import "./App.css";
import { useAuth } from "./hooks/useAuth";
import { isDemoMode } from "./firebase";
import Welcome from "./pages/Welcome";
import Login from "./pages/Login";
import Signup from "./pages/Signup";
import Onboarding from "./pages/Onboarding";
import Dashboard from "./pages/Dashboard";
import Search from "./pages/Search";
import ConnectionProfile from "./pages/ConnectionProfile";
import Profile from "./pages/Profile";

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="loading-center" style={{ minHeight: "100vh" }}>
        <div className="spinner" />
      </div>
    );
  }
  if (isDemoMode) return children;
  return user ? children : <Navigate to="/login" replace />;
}

function RootRedirect() {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="loading-center" style={{ minHeight: "100vh" }}>
        <div className="spinner" />
      </div>
    );
  }
  if (isDemoMode) return <Navigate to="/dashboard" replace />;
  // Logged-out visitors land on the product page, not straight on a login form.
  return <Navigate to={user ? "/dashboard" : "/welcome"} replace />;
}

export default function App() {
  return (
    <BrowserRouter>
      {/* Page-view analytics. Mounted only where it can actually report —
          on Firebase Hosting its script 404s into index.html and throws.
          Set REACT_APP_VERCEL_ANALYTICS=true to force it on a custom domain. */}
      {isVercelHosted() && <Analytics />}
      <Routes>
        <Route path="/" element={<RootRedirect />} />
        <Route path="/welcome" element={<Welcome />} />
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<Signup />} />
        <Route
          path="/onboarding"
          element={
            <ProtectedRoute>
              <Onboarding />
            </ProtectedRoute>
          }
        />
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/connections/:connectionId"
          element={
            <ProtectedRoute>
              <ConnectionProfile />
            </ProtectedRoute>
          }
        />
        <Route
          path="/search"
          element={
            <ProtectedRoute>
              <Search />
            </ProtectedRoute>
          }
        />
        <Route
          path="/profile"
          element={
            <ProtectedRoute>
              <Profile />
            </ProtectedRoute>
          }
        />
      </Routes>
    </BrowserRouter>
  );
}
